import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { T } from '../traks';
import { InfoToolTip } from './InfoToolTip';
import {dataPlaceholder, formatWithSeparators} from '../misc'
import Logo from './Logo';

const getLink = () => {
  if (IS_AKTIEDYSTEN_DK) {
    return "https://inspiration.aktiedysten.dk/vaekst-din-viden-hvem-og-hvad-er-aktivet/";
  } else if (IS_AKTIEKAMPEN_SE) {
    return "https://undervisning.aktiekampen.se/oka-din-kunskap/";
  } else if (IS_INVESTSPIEL_DE) {
    return "https://investspiel.de";
  } else if (IS_TRADERR_COM) {
    return "https://traderr.com";
  } else {
    return "#";  
  }
}



//Component to display relevant info about the currently selected company
export const CompanyInfo = (props) => {
  const link = getLink();

  const formattedNumberOfShares = props.marketData ? formatWithSeparators(props.marketData.StockAmount) : '';
  const formattedMarketCap = props.marketData ? formatWithSeparators(props.marketData.MarketCap) : '';

  return (
    <div className="py-4 px-3 d-lg-flex">
      <Card className='ad_company_info_card ad_company_info_card_company'>
        <CardBody className='p-2'>
          <div className='d-flex ad_company_info_card_header'>
            <h1><T>Who is</T> {dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.LocalName : '')}</h1>
            <InfoToolTip
                  title={<T>Who is</T>} 
                  tooltipText={<T><p><strong>What is it?</strong> It's the company's "bio" – a quick description of what they do and what they stand for. Think of it as the company's intro! If you want to know more, you can always check their website and dive into the interesting details.</p>
                  <p><strong>Why is it important?</strong> If you're a shareholder, it's pretty smart to know what the company does. It helps you understand whether you believe in their mission and industry. Are they in a field that seems exciting and innovative? Or is there a risk that they're heading downhill?</p>
                  <p>And remember: the CEO is like the team's captain! A strong leader with a good track record can make a big difference for the company’s future.</p>
                  </T>} 
                  link={link} 
                />
          </div>
          <p className='pb-3'>
          {dataPlaceholder(props.businessDescription)}
          </p>
          <p><strong><T>Website</T>: </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.WebAddress : '')}</p>
          <p><strong><T>Head office</T>: </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.HeadOffice : '')}</p>
          <div className='ad_company_info_card_logo'><Logo size={60} className="my-auto" exchange={props.exchange} ticker={props.ticker}/></div>
        </CardBody>
      </Card>
      <Card className='ad_company_info_card ad_company_info_card_security my-3 my-lg-0 mx-lg-3'>
        <CardBody className='p-0'>
         <div className='d-flex ad_company_info_card_header ad_company_info_card_security_header'>
            <h1 className=''><T>The security</T></h1>
            <InfoToolTip
                  title={<T>The security</T>} 
                  tooltipText={<T>
                    <p>This provides important information about the stock itself and its market status.</p>
                    <p>- <strong>Number of owners:</strong> Think of it as the stock's ‘fanbase’! If many people have it, it indicates that people trust the company.</p>
                    <p>- <strong>Number of Shares:</strong> This is the total number of shares the company has issued. It tells you how many ‘pieces’ of the company exist. It gives you an idea of how big the company is and how much of it can be owned by investors.</p>
                    <p>- <strong>Market capitalisation:</strong> This is the total value of all the company's shares (share price times number of shares). It tells you how much the company is worth on the stock market, which is important when assessing whether it's a good investment.’</p>
                  </T>} 
                  link={link}
                />
          </div>
          <div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Number of owners</T>: </strong>{dataPlaceholder(props.NumberOfShareHolders)}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong>Ticker: </strong>{dataPlaceholder(props.ticker)}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Number of Shares</T>: </strong>{dataPlaceholder(formattedNumberOfShares)}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Market capitalisation</T>: </strong>{dataPlaceholder(formattedMarketCap)}
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
      <Card className='ad_company_info_card ad_company_info_card_security'>
        <CardBody className='p-0'>
         <div className='d-flex ad_company_info_card_header ad_company_info_card_security_header'>
            <h1 className=''><T>Which Market</T></h1>
            <InfoToolTip
                  title={<T>Which Market</T>} 
                  tooltipText={<T>
                    <p>Here, you’ll get info on which sector, industry, and country the company operates in. It’s pretty smart to know this because it can help you diversify your portfolio and reduce risk.</p>
                    <p>• <strong>Sector:</strong> This is the broad category the company belongs to. It helps you understand which part of the economy affects the company. Some sectors are more stable than others, like healthcare, while others are more volatile, like technology.</p>
                    <p>• <strong>Industry:</strong> This is the more specific part of the sector the company operates in, like medical equipment within the healthcare sector. Industries have different growth rates and risks, and knowing this helps you compare the company with others in the same niche.</p>
                    <p>• <strong>Country:</strong> The country matters because taxes, regulations, and the overall economy can impact the company. As a shareholder, it’s smart to know if the company operates in a stable country or in a place with uncertain market conditions. This can be the difference between a safe investment or a wild rollercoaster ride!</p>
                  </T>} 
                  link={link}
                />
          </div>
          <div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Sector:</T> </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.SectorName : '')}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Industry:</T> </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.IndustryName : '')}
              </span>
            </div>
            <div className='ad_company_info_card_security_info'>
              <span>
              <strong><T>Country:</T> </strong>{dataPlaceholder(props.companyGeneralInfo ? props.companyGeneralInfo.Country : '')}
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/c/CompanyInfo.js